import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { toolNameMap } from '../../types';
import { type ChatMessagePart, getToolLoadingKey, isActiveToolPart } from './utils';

const ToolLoadingList = ({ parts }: { parts: ChatMessagePart[] }) => {
  const { t } = useTranslation('ai');
  const activeToolParts = parts.filter(isActiveToolPart);

  if (activeToolParts.length === 0) return null;

  return (
    <div className='flex flex-col gap-1 rounded-lg border border-gray-4 bg-white/60 px-3 py-2 shadow-sm'>
      {activeToolParts.map((part, index) => {
        const toolName = toolNameMap[part.type] || t('tool_loading_fallback');
        return (
          <div key={getToolLoadingKey(part, index)} className='flex min-h-7 items-center gap-2 text-gray-10'>
            <Icon name='loader-circle' size='sm' className='size-4 shrink-0 animate-spin text-primary-9' />
            <Typography variant='text-sm' className='min-w-0 truncate text-gray-10'>
              {toolName}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default ToolLoadingList;
